import { ODataVersion } from "../service/planner/common/IOdataEntityResource";
/**
 * Sets the etag value on an entity, using the appropriate property name for the version
 * @param entity The OData entity
 * @param etag The etag value to set
 * @param version The OData version
 */ export function setEtag(entity, etag, version) {
    if (version === ODataVersion.Modern) {
        entity["@etag"] = etag;
        delete entity["@odata.etag"];
    } else {
        entity["@odata.etag"] = etag;
        delete entity["@etag"];
    }
}
/**
 * Parse link values from an OData entity collection response based on version
 * @param responseData The OData entity collection response data
 * @param version The OData version
 * @returns nextLink and deltaLink values
 */ export function parseEntityCollectionResponseLinks(responseData, version) {
    let nextLink;
    let deltaLink;
    if (version === ODataVersion.Modern) {
        nextLink = responseData["@nextLink"];
        deltaLink = responseData["@deltaLink"];
    } else if (version === ODataVersion.Legacy) {
        nextLink = responseData["@odata.nextLink"];
        deltaLink = responseData["@odata.deltaLink"];
    }
    return {
        nextLink,
        deltaLink
    };
}
